import { useState } from "react";
import { useAuthContext } from '@/context/AuthContext';
import {userManager} from '@/components/authentication/keycloak.js';

export const useGetCompanyBenefitInvoice = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const getCompanyBenefitInvoice = async (companyBenefitInvoiceFileUuid) => {
        setLoading(true);
        setError(null);
        const user = await userManager.getUser();

        try {
            const response = await fetch(window.ENV.BACKEND_URL+`/api/secured/users/companyBenefit/companyBenefitInvoiceFile/${companyBenefitInvoiceFileUuid}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to retrieve company benefit invoice");
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            // console.log("blob file companyBenefit ", blob, url)

            setData({ url, type: blob.type });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { getCompanyBenefitInvoice, loading, error, data };
};
